import { PreviewDto } from "../../../../types/schedule/preview-dto";
import { convertPreviewDtoToPreview } from "../../../../utils/converter/schedule/preview-converter";
import { ScheduleState } from "../../../type/schedule-state";

interface Action {
  type: string;
  payload: {
    previewDto: PreviewDto;
  };
}

export const setPreviewDispatch = (state: ScheduleState, action: Action) => {
  const { previewDto } = action.payload;
  const { deliverySegments, deliveryGroups } = convertPreviewDtoToPreview(
    previewDto,
    state.updateSchedule?.currentDeliveryGroupIndex
  );
  state.preview = deliveryGroups;
  state.deliverySegments = deliverySegments;
};
